<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      registration: null,
      updateExists: false,
      refreshing: false,
    }
  },
  created() {
    document.addEventListener('swUpdated', this.updateAvailable, { once: true })
    if (navigator.serviceWorker) {  
      navigator.serviceWorker.addEventListener(
        'controllerchange', () => {
          if (this.refreshing) return;
          this.refreshing = true;
          window.location.reload();
        }
      );
    }
  },
  methods: {
    async updateAvailable(event) {
      console.log('test inside update')
      this.registration = event.detail
      this.updateExists = true
      console.log('New content is available; Refreshing page in 10 seconds.')
      const delay = ms => new Promise(res => setTimeout(res, ms));
      await delay(10000)
      window.alert('hey')
      this.registration.waiting.postMessage('skipWaiting')
    },
  },
}
</script>

<style>
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed, 
figure, figcaption, footer, header, hgroup, 
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 100%;
	font: inherit;
	vertical-align: baseline;
  color: white
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure, 
footer, header, hgroup, menu, nav, section {
	display: block;
}
body {
	line-height: 1;
}
ol, ul {
	list-style: none;
}
blockquote, q {
	quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
	content: '';
	content: none;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}
button {
  color: black;
}
#app {
  font-family: 'Mukta', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
  width: 100vw;
  height: 100vh;
}
.ant-message-notice.message-success span, .ant-message-custom-content.ant-message-error span {
  color: black;
}
.ant-message-notice.message-success span:first-child {
  color: #52c41a
}
.ant-message-custom-content.ant-message-error span:first-child {
  color: #ff4d4f
}
</style>
